import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetMentors } from "../services/AppointmentsService";
import { updateMentors } from "../store/slices/mentorsSlice";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { GetMentorCohorts, GetMyCohorts } from "../services/cohortService";
import { updateCohortTimezone } from "./cohortHelpers";

export const useMyCohorts = (username) => {
  const qalortUser = useSelector((state) => state.user.userData);
  const key = "myCohorts";

  // Queries
  const query = useQuery({
    queryKey: [key, username],
    queryFn: async () => {
      const data = await GetMyCohorts();
      return updateCohortTimezone(data.data.data.reverse());
    },
  });

  return query;
};
